import type { ReactElement } from 'react';
import { RealtimeMessageType } from '@gr/core/platform/system/realtime';
import { useConfig, useRealtimeMessages, useServices, useT } from '../../../app/di';
import { useResource } from '../../../shared/hooks';
import { Alert } from '../../../ui-kit/Alert/Alert';
import { Button } from '../../../ui-kit/Button/Button';
import { EmptyState } from '../../../ui-kit/EmptyState/EmptyState';
import { Loading } from '../../../ui-kit/Loading/Loading';
import { PageHeader } from '../../../ui-kit/PageHeader/PageHeader';
import { useBlog } from '../../accounts/workspaces';
import { DueList } from './DueList/DueList';

// PUB-UC-1
export function DuePage(): ReactElement {
  const { api } = useServices();
  const { ui } = useConfig();
  const { t } = useT();
  const { blog } = useBlog();
  const due = useResource(() => api.publishing.due(blog.id), [api, blog.id]);
  // PUB-UC-7, SYS-UC-13: время публикации наступило или её отметили — список обновляется сам.
  useRealtimeMessages((message) => {
    if (message.type === RealtimeMessageType.DueCount && message.blogId === blog.id && message.count !== due.data?.length) void due.reload();
  });

  return (
    <div className="u-stack-lg">
      <PageHeader title={t('publishing.due.title')} subtitle={t('publishing.due.subtitle')} />
      {due.loading && !due.data ? (
        <Loading label={t('common.loading')} />
      ) : due.error ? (
        <Alert tone="danger" title={t('common.loadFailed')}>
          <Button size="sm" onClick={() => void due.reload()}>
            {t('common.retry')}
          </Button>
        </Alert>
      ) : !due.data || due.data.length === 0 ? (
        <EmptyState title={t('publishing.due.empty')} text={t('publishing.due.emptyText')} />
      ) : (
        <DueList blogId={blog.id} timezone={blog.timezone} publications={due.data} now={Date.now()} onTimeMinutes={ui.publishing.onTimeMinutes} />
      )}
    </div>
  );
}
